import http from '../_http_v2';

const login = {
  //user
  userList: (m) => { return http.post(`console/log/login/user/list`, m); },
  userDetail: (m) => { return http.get(`console/log/login/user/${m.id}`); },

  //admin
  adminList: (m) => { return http.post(`console/log/login/admin/list`, m); },
  adminDetail: (m) => { return http.get(`console/log/login/admin/${m.id}`); },

  //partner
  partnerList: (m) => { return http.post(`console/log/login/partner/list`, m); },
  partnerDetail: (m) => { return http.get(`console/log/login/partner/${m.id}`); },
}

export default login

export { login }